import type { Theme } from '@mui/material/styles';

/**
 * Theme extension to fix Atlas theme's MUI Tabs component
 * This restores standard MUI Tabs behavior by removing unwanted padding
 */
export const createTabsThemeOverride = (theme: Theme): Theme => {
  return {
    ...theme,
    components: {
      ...theme.components,
      MuiTabs: {
        ...theme.components?.MuiTabs,
        styleOverrides: {
          ...theme.components?.MuiTabs?.styleOverrides,
          flexContainer: {
            ...(theme.components?.MuiTabs?.styleOverrides?.flexContainer as object || {}),
            paddingBottom: 0,
          },
          root: {
            ...(theme.components?.MuiTabs?.styleOverrides?.root as object || {}),
            minHeight: 'auto',
          },
        },
      },
    },
  };
}; 